<template>
<div class="chapter">
<div class="inner_page">
<div id="Glossary">
<p class="fm-title"><a id="page_xi"><b>Glossary</b></a></p><a id="page_xi">
<p class="h1"><b><i>Waffen SS</i> Ranks and British Army Equivalents:</b></p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="35%"/>
<col width="65%"/>
</colgroup>
<tbody>
<tr>
<td align="left" valign="top"><p class="table-para"><i>SS Obersturmbannführer</i></p></td>
<td align="left" valign="top"><p class="table-para1">Lieutenant Colonel</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>SS Sturmbannführer</i></p></td>
<td align="left" valign="top"><p class="table-para1">Major</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>SS Hauptsturmführer</i></p></td>
<td align="left" valign="top"><p class="table-para1">Captain</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>SS Obersturmführer</i></p></td>
<td align="left" valign="top"><p class="table-para1">Lieutenant</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>SS Untersturmführer</i></p></td>
<td align="left" valign="top"><p class="table-para1">2nd Lieutenant</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>SS Standartenoberjunker</i></p></td>
<td align="left" valign="top"><p class="table-para1">(no equivalent)</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>SS Hauptscharführer</i></p></td>
<td align="left" valign="top"><p class="table-para1">Battalion Sergeant Major</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>SS Oberscharführer</i></p></td>
<td align="left" valign="top"><p class="table-para1">Company Sergeant Major</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>SS Scharführer</i></p></td>
<td align="left" valign="top"><p class="table-para1">Platoon Sergeant Major</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>SS Unterscharführer</i></p></td>
<td align="left" valign="top"><p class="table-para1">Sergeant</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>SS Rottenführer</i></p></td>
<td align="left" valign="top"><p class="table-para1">Corporal</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>SS Sturmmann</i></p></td>
<td align="left" valign="top"><p class="table-para1">Lance Corporal</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>SS Oberschütze</i></p></td>
<td align="left" valign="top"><p class="table-para1">Private First Class [US rank]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>SS Schütze</i></p></td>
<td align="left" valign="top"><p class="table-para1">Private</p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="h1"><b>Other terms:</b></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Ausbildung</i></p></td>
<td align="left" valign="top"><p class="table-para1">training [German]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Davai</i></p></td>
<td align="left" valign="top"><p class="table-para1">‘hurry’ [Russian]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Du meine Fresse</i></p></td>
<td align="left" valign="top"><p class="table-para1">‘bloody hell!’ [German]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Fils de salop</i></p></td>
<td align="left" valign="top"><p class="table-para1">‘son of a bitch’ [French]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Heeresgruppe</i></p></td>
<td align="left" valign="top"><p class="table-para1">Army Group [German]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Karrotenkopf</i></p></td>
<td align="left" valign="top"><p class="table-para1">red-haired person, meaning ‘carrot head’ [German]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Kriegsmarine</i></p></td>
<td align="left" valign="top"><p class="table-para1">navy [German]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Kübelwagen</i></p></td>
<td align="left" valign="top"><p class="table-para1">German military vehicle similar to jeep</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>niaqué</i></p></td>
<td align="left" valign="top"><p class="table-para1">Vietnamese female farm worker</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Matrose</i></p></td>
<td align="left" valign="top"><p class="table-para1">naval rating [German]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Maudit</i></p></td>
<td align="left" valign="top"><p class="table-para1">‘goddam or damn it’[French]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Munitionschütze</i></p></td>
<td align="left" valign="top"><p class="table-para1">soldier responsible for keeping a field piece supplied with ammunition [German]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><a id="page_xii"><i>Ostarbeiter</i></a></p></td>
<td align="left" valign="top"><p class="table-para1">a worker from the east – often Russian [German]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Panzerfaust (pl.Panzerfäuste)</i></p></td>
<td align="left" valign="top"><p class="table-para1">a rocket-propelled anti-tank weapon [German]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Pioniere</i></p></td>
<td align="left" valign="top"><p class="table-para1">field engineers [German]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Porco boia</i></p></td>
<td align="left" valign="top"><p class="table-para1">Italian expletive</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Prévôtè</i></p></td>
<td align="left" valign="top"><p class="table-para1">Provost [French]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>rez-de-chaussée</i></p></td>
<td align="left" valign="top"><p class="table-para1">the ground floor storey of a building [French]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Richtschütze</i></p></td>
<td align="left" valign="top"><p class="table-para1">gun-layer [German]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>roulante</i></p></td>
<td align="left" valign="top"><p class="table-para1">mobile field kitchen [French]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Scheisse</i></p></td>
<td align="left" valign="top"><p class="table-para1">‘shit’ [German]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Soldbuch (pl. Soldbücher)</i></p></td>
<td align="left" valign="top"><p class="table-para1">German soldier’s identity and pay book</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Sommelier</i></p></td>
<td align="left" valign="top"><p class="table-para1">trained wine steward in an expensive restaurant</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Sigrun</i></p></td>
<td align="left" valign="top"><p class="table-para1">the angular double ‘S’ symbol used by the <i>SS</i></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Standartenoberjunker</i></p></td>
<td align="left" valign="top"><p class="table-para1">most senior rank of an <i>SS</i> officer candidate</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>tholang</i></p></td>
<td align="left" valign="top"><p class="table-para1">Vietnamese head of a village</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>tirailleur</i></p></td>
<td align="left" valign="top"><p class="table-para1">Senegalese rifleman</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Truppführer</i></p></td>
<td align="left" valign="top"><p class="table-para1">troop leader [German]</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Volkssturm</i></p></td>
<td align="left" valign="top"><p class="table-para1">German reserve force composed of male civilians</p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="table-para"><i>Zeltbahn (pl. Zeltbahen)</i></p></td>
<td align="left" valign="top"><p class="table-para1">waterproof tent quarter carried by German soldiers</p></td>
</tr>
</tbody>
</table>
</a></div><a id="page_xi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Glossary.vue?ecd28c8c